import { useScriptLoad } from './hooks';

export function FueledCheckmateScript({ withKey: storeDomain }) {
  useScriptLoad(
    {
      id: 'fueled-checkmate',
      src: `https://${storeDomain}/apps/cm/v1/load?source=gtm`,
    },
    'head'
  );

  return null;
}
